export class Filtro {
  dtInicio: number;
  dtFim: number;
  limiteRegistros = 0;
  produtos: any;
}
